var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M.7 5.7C.7 4.2 2 3 3.5 3h16c1.5 0 2.8 1.2 2.8 2.8v10c0 1.5-1.2 2.7-2.8 2.7h-16C2 18.5.7 17.3.7 15.8V5.7zm2.8-1.2c-.7 0-1.2.6-1.2 1.2v10c0 .7.6 1.2 1.2 1.2h16c.7 0 1.2-.6 1.2-1.2v-10c0-.7-.6-1.2-1.2-1.2h-16z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M16.6 8.5c.3.3.3.8 0 1.1L13 13.2c-.1.1-.3.2-.5.2s-.4-.1-.5-.2L9.7 11l-2.2 2.2c-.3.3-.8.3-1.1 0-.3-.3-.3-.8 0-1.1l2.7-2.7c.1-.1.3-.2.5-.2s.4.1.5.2l2.2 2.2 3.1-3.1c.4-.3.9-.3 1.2 0zm-8.4 9c.4.2.6.6.4 1l-1.8 4.1c-.2.4-.6.6-1 .4-.4-.2-.6-.6-.4-1l1.8-4.1c.2-.3.6-.5 1-.4zm6.6 0c-.4.2-.6.6-.4 1l1.8 4.1c.2.4.6.6 1 .4.4-.2.6-.6.4-1l-1.8-4.1c-.2-.3-.6-.5-1-.4zM11.2 1.2c.5 0 .8.4.8.8v1.5c0 .4-.3.8-.8.8-.4 0-.8-.3-.8-.8V2c.1-.4.4-.8.8-.8z",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/Whiteboard.9716c17b7d0910e5883e4367a4e52ac7.svg";
export { ForwardRef as ReactComponent };